import image1 from "./Rectangle 1.png";
import image2 from "./Rectangle 2.png";
import image3 from "./Rectangle 3.png";
import image4 from "./Rectangle 4.png";
import image5 from "./Rectangle 5.png";
import image6 from "./Rectangle 6.png";

const imagesData = [
  {
    id: "image1",
    imgSrc: image1,
    title: "Clothes"
  },
  {
    id: "image2",
    imgSrc: image2,
    title: "Jewelery"
  },
  {
    id: "image3",
    imgSrc: image3,
    title: "Instruments"
  },
  {
    id: "image4",
    imgSrc: image4,
    title: "Spices"
  },
  {
    id: "image5",
    imgSrc: image5,
    title: "HandiCrafts"
  },
  {
    id: "image6",
    imgSrc: image6,
    title: "Art and Crafts"
  },
];

export default imagesData